module.exports = __webpack_public_path__ + "img/football_vertical.901efbe4.jpg";